requestAnimationFrame(() => {
  class BackToTop extends HTMLElement {
    constructor() {
      super();

      themeBase.onDOMContentLoadedTrigger(() => {
        this.lastScrollY = 0;
        this.limit = 800;
        this.duration = 1500;
        this.button = this.querySelector('a');

        this.button.addEventListener('click', this.onClick.bind(this));
      });
    }

    onClick(event) {
      event.preventDefault();

      document.body.classList.add('body-scroll-top');
      setTimeout(() => document.body.classList.add('body-scroll-top--animated'));

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  customElements.define('back-to-top', BackToTop);
});